import { Host, h } from '@stencil/core';
export class AibaSelfieIntroScreen {
  constructor() {
    this.getData = undefined;
    this.handlers = undefined;
    this.data = undefined;
  }
  async componentWillLoad() {
    if (this.getData) {
      this.data = await this.getData();
    }
    if (this.handlers && this.handlers.handleSelfieIntroScreenWillLoad) {
      this.handlers.handleSelfieIntroScreenWillLoad();
    }
  }
  render() {
    var _a, _b;
    return (h(Host, { class: "selfie-intro-screen-wrapper" }, h("div", { class: "selfie-grid-wrapper" }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((component) => {
        var _a, _b;
        if (component['name'] === 'aiba-video')
          return h("aiba-video", Object.assign({}, component, { handlers: this.handlers }));
        if (component['name'] === 'aiba-label')
          return h("aiba-label", Object.assign({}, component['data'], { handlers: this.handlers }));
        if (component['name'] === 'aiba-hero-image')
          return (h("div", { class: "hero-image" }, h("aiba-hero-image", { image: (_a = component === null || component === void 0 ? void 0 : component.data) === null || _a === void 0 ? void 0 : _a.image, altText: (_b = component === null || component === void 0 ? void 0 : component.data) === null || _b === void 0 ? void 0 : _b.altText })));
        if (component['name'] === 'aiba-selfie-content')
          return h("aiba-selfie-content", { handlers: this.handlers, data: component === null || component === void 0 ? void 0 : component.data });
        if (component['name'] === 'aiba-selfie-content-modal')
          return (h("div", { class: "selfie-content-modal" }, h("aiba-selfie-content-modal", { handlers: this.handlers, data: component === null || component === void 0 ? void 0 : component.data })));
        if (component['name'] === 'aiba-icon')
          return h("aiba-icon", Object.assign({}, component['data']));
      })))));
  }
  static get is() { return "aiba-selfie-intro-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-intro-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-intro-screen.css"]
    };
  }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {}
    };
  }
}
//# sourceMappingURL=aiba-selfie-intro-screen.js.map
